import { from, Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';


/**
 * Helper function to create an Observable that emits a single value from a Subject and then
 * completes, without the need to handle subscription.
 *
 * NOTE: Use this helper function instead of `sourceSubject.asObservable()` if you need to react to
 * a single value.
 */
export const takeOneValueFromSubject = <T>(sourceSubject: Subject<T>): Observable<T> => {
  return from(sourceSubject).pipe(
    take(1),
  );
};
